import { getGameLobby } from "api/game-lobby/get-game-lobby";
import subscribeToStream from "api/utils/subscribe-to-stream";
import { GameLobbyPayload } from "models/GameLobbyPayload";
import { buildGameLoggyTypeFromGameLobbyPayload, GameLobbyType } from "models/GameLobbyType";

type SubscribeArgs = { lobbyId: string; onLobbyUpdate: (lobby: GameLobbyType | null) => void };
type CleanupFn = () => void;

export const subscribeToGameLobbyStream = ({
  lobbyId,
  onLobbyUpdate,
}: SubscribeArgs): CleanupFn => {
  return subscribeToStream<GameLobbyType>({
    resourcePath: `/api/game-lobby/${lobbyId}/stream`,
    fetchLatest: () => getGameLobby(lobbyId),
    parseMessage: (data) => buildGameLoggyTypeFromGameLobbyPayload(data as GameLobbyPayload),
    onUpdate: onLobbyUpdate,
  });
};

export default subscribeToGameLobbyStream;
